import React from "react";
import { FaX, FaLocationDot, FaPhone, FaEnvelope, FaClock } from "react-icons/fa6";

const DatosContacto = ({ onClose }) => {
  return (
    <div className="historico-seguimiento">
      <div className="modal-content">
        <div className="modal-header mayusculas">
          <h2> Nombre de la entidad de contacto</h2>
          <button className="close-button" onClick={onClose}><FaX /></button>
        </div>
        <div className="modal-body column gap-5">
          <p className="align-center mt-10 gap-5">
            <FaLocationDot className="verde" /> Dirección completa del sitio
          </p>
          <p className="align-center mt-10 gap-5">
            <FaPhone className="verde" /> 123 456 789
          </p>
          <p className="align-center mt-10 gap-5">
            <FaEnvelope className="verde" /> info@islacristina.es
          </p>
          <p className="align-center mt-10 gap-5">
            <FaClock className="verde" /> De 9:00 a 13:00
          </p>
        </div>
      </div>
    </div>
  );
};

export default DatosContacto;